import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trophy } from "lucide-react";
import LegoConfetti from "@/components/landing/LegoConfetti";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ScoreSubmit({ game, score, scoreLabel }) {
  const [name, setName] = useState("");
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [champion, setChampion] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      const r = await axios.post(`${API}/scores`, { name: name.trim(), game, score });
      setSaved(true);
      window.dispatchEvent(new Event("wfi-score-saved"));
      if (r.data.rank === 1) {
        setChampion(true);
        toast.success("NEW #1 ON THE BOARD! You lead the WillFixIt leaderboard!");
      } else {
        toast.success("Score saved to the leaderboard — challenge your friends to beat it!");
      }
    } catch (err) {
      toast.error("Could not save your score. Try again.");
    } finally {
      setSaving(false);
    }
  };

  if (saved) {
    return (
      <>
        {champion && <LegoConfetti onDone={() => setChampion(false)} />}
        <a
          href="#leaderboard"
          data-testid={`score-saved-link-${game}`}
          className="inline-flex items-center gap-2 mt-3 text-xs font-bold text-[#D4691E] hover:underline"
        >
          <Trophy className="w-4 h-4" /> {champion ? "You're #1 — see your name on top" : "Score saved — see the leaderboard"}
        </a>
      </>
    );
  }

  return (
    <form onSubmit={submit} className="mt-4 flex flex-wrap items-center justify-center gap-2 max-w-full" data-testid={`score-form-${game}`}>
      <input
        type="text"
        maxLength={24}
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Your name for the leaderboard"
        data-testid={`score-name-input-${game}`}
        className="px-3 py-2 rounded-lg bg-[#FBF9F5] border border-[#E6DCD3] text-[#1E252B] placeholder-[#A39B92] text-xs focus:outline-none focus:border-[#D4691E] min-w-0 w-full sm:w-52"
      />
      <button
        type="submit"
        disabled={saving}
        data-testid={`score-submit-btn-${game}`}
        className="px-4 py-2 rounded-lg bg-[#1E252B] hover:bg-[#D4691E] disabled:opacity-60 text-white text-xs font-bold transition-colors"
      >
        {saving ? "Saving..." : `Save ${score} ${scoreLabel}`}
      </button>
    </form>
  );
}
